import Breadcrumb from "../../Breadcrumb/Breadcrumb";
import HonariButton from "../../Button/HonariButton";
import { useEffect, useRef, useState } from "react";
import axios from "axios";
import * as Constants from "../../../constants/urls";
import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

export default function OrderCheck() {
  const [defualt, setDefualt] = useState(undefined);
  const [oldBasket, setOldBasket] = useState();
  const [newBasket, setNewBasket] = useState();
  const [checker, setChecker] = useState();
  const [data, setData] = useState(undefined);

  const oldBasketRef = useRef(null);
  const newBasketRef = useRef(null);
  const buttonRef = useRef(null);

  const [cookies, setCookie, removeCookie] = useCookies();
  const navigate = useNavigate();
    function getData() {
    const url = Constants.apiUrl + "/api/getHasRoleUsers";
    axios
      .get(url, {
        headers: {
          Authorization: "Bearer " + cookies.user_server_token,
        },
      })
      .then((r) => {
        setData(r.data);
      })
      .catch((e) => {});
  }

  const handleKeyDown = (e, nextRef, isButton = false) => {
    if (e.key === "Enter") {
      e.preventDefault(); // جلوگیری از رفتار پیش‌فرض فرم
      if (isButton) {
        // اگر دکمه باشد، کلیک را اجرا کن
        startCheck()
        
      } else {
        // در غیر این صورت فوکوس را به المان بعدی بده
        nextRef.current?.focus();
      }
    }
  };

  useEffect(() => {
    oldBasketRef.current?.focus(); // فوکوس پیش‌فرض روی اینپوت اول
  }, []);
  function getdefualtData() {
    const url = Constants.apiUrl + "/api/order/lastChecker";
    axios
      .get(url, {
        headers: {
          Authorization: "Bearer " + cookies.user_server_token,
        },
      })
      .then((r) => {
        setDefualt(r.data.data);
        setChecker(r.data.data.user_id);
      })
      .catch((e) => {});
  }
  useEffect(() => {
    getData();
    getdefualtData();
  }, []);

  const startCheck = () => {
    const url = Constants.apiUrl + "/api/order/setBasket";
    axios
      .post(
        url,
        {
          old: oldBasket,
          new: newBasket,
          checker: checker,
        },
        {
          headers: {
            Authorization: "Bearer " + cookies.user_server_token,
          },
        }
      )
      .then((r) => {
        console.log("R",r);
        
        navigate('/admin/orders/factor_checking_barcode/'+r.data.data.id+"?userId="+checker);
      })
      .catch((e) => {
        toast.error(e.response.data);

      });
  };
  return (
    <>
      <Breadcrumb title={"چک کردن"} />
      <div className="flex flex-col gap-5 text-right p-5">
        <div>
          <label>بارکد سبد قبلی</label>
          <input
            placeholder="سبد قبلی"
            value={oldBasket}
            onKeyDown={(e) => handleKeyDown(e, newBasketRef)}
            onChange={(e) => {
              setOldBasket(e.target.value);
            }}
            ref={oldBasketRef}
            type="text"
            class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 "
          />
        </div>
        <div>
          <label>بارکد سبد جدید</label>
          <input 
            value={newBasket}
            ref={newBasketRef}
            onKeyDown={(e) => handleKeyDown(e, null, true)}
            onChange={(e) => {
              setNewBasket(e.target.value);
            }}
            placeholder="سبد جدید"
            type="text"
            class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 "
          />
        </div>

        <div>
          <label>چک کننده</label>
          <select
            onChange={(e) => {
              setChecker(e.target.value);
            }}
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 "
          >
            {data &&
              defualt &&
              data.map((item) => (
                <option value={item.id} selected={item.id == defualt?.user_id}>
                  {item.name}
                </option>
              ))}
          </select>
        </div>
        <HonariButton  ref={buttonRef} onClick={startCheck}> شروع چک </HonariButton>
      </div>
    </>
  );
}
